import { Reveal } from "@/components/Reveal";

const STATS = [
  { value: "50+", label: "Firme partenere", testid: "why-stat-partners" },
  { value: "30+", label: "Furnizori de materiale", testid: "why-stat-suppliers" },
  { value: "1", label: "Punct de contact", testid: "why-stat-contact" },
];

const CHAIN = ["Analizăm", "Găsim soluția", "Organizăm echipa", "Procurăm materialele", "Coordonăm lucrarea"];

export default function WhyBrox() {
  return (
    <section className="bg-ink-950 py-14 sm:py-24" data-testid="why-brox-section">
      <div className="container-brox">
        <Reveal>
          <p className="eyebrow mb-4">DE CE BROX CONSTRUCT</p>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="display-title max-w-5xl text-4xl sm:text-6xl lg:text-7xl" data-testid="why-brox-title">
            Tu ne spui ce ai nevoie.<br />
            <span className="text-copper">Noi organizăm restul.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-muted-foreground sm:text-lg" data-testid="why-brox-copy">
            De la o reparație de o oră până la renovarea completă a unei proprietăți, Brox Construct îți oferă
            un singur punct de contact pentru echipe, specialiști și materiale. Nu mai căuta 10 meseriași
            pentru un singur proiect.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-col gap-4 border border-white/10 bg-ink-900 p-6 sm:p-8" data-testid="why-brox-chain">
            <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
              <span className="copper-sheen px-4 py-2 font-display text-lg font-extrabold uppercase tracking-wider text-ink-950">TU</span>
              <p className="text-sm text-paper/80">Ne spui ce vrei să faci sau ce problemă ai.</p>
            </div>
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-copper sm:w-12" aria-hidden="true" />
              <span className="font-display text-xl font-extrabold uppercase tracking-wider text-copper">BROX</span>
              <span className="h-px flex-1 bg-copper/40" aria-hidden="true" />
            </div>
            <ol className="grid gap-2 sm:grid-cols-5 sm:gap-3">
              {CHAIN.map((step, i) => (
                <li key={step} className="flex items-center gap-2 border border-white/10 bg-ink-950 px-3 py-2.5">
                  <span className="font-mono text-[10px] text-copper">{i + 1}</span>
                  <span className="text-xs text-paper/80 sm:text-[11px]">{step}</span>
                </li>
              ))}
            </ol>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-copper" data-testid="why-brox-promise">
              Un singur contact. Tot proiectul.
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid gap-px overflow-hidden border border-white/10 bg-white/10 md:grid-cols-3" data-testid="why-brox-stats">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={0.08 * i} className="bg-ink-900">
              <div className="flex h-full flex-col gap-2 p-6 sm:p-8">
                <span className="font-display text-5xl font-extrabold text-copper sm:text-6xl" data-testid={s.testid}>
                  {s.value}
                </span>
                <span className="font-display text-lg font-bold uppercase tracking-wide text-paper">{s.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
